import en from "date-fns/locale/en"
import ja from "date-fns/locale/ja"

export default {
  computed: {
    locale () {
      return this.$store.state.global.setting.locale
    }
  },
  methods: {
    getDate(date) {
      let format = this.useFormat();
      let locale = this.useLocale();
      return this.$date(date, format, { locale });
    },
    useFormat(){
      switch(this.locale){
        case "ja": return "YYYY年MM月DD日(dd)";
        case "en": return "dddd, MMMM Do, YYYY";
        default: return "dddd, MMMM Do, YYYY";
      }
    },
    useLocale(){
      switch(this.locale){
        case "ja": return ja;
        case "en": return en;
        default: return en;
      }
    }
  }
}
